import Phaser from 'phaser';
import type { CosmeticLoadout } from '../data/cosmetics';
import type { PlayerSettings } from '../services/save';
import { BattleScene, type RuntimeFrame } from './render/BattleScene';
import { Simulation } from './simulation/Simulation';
import { WORLD_HEIGHT, WORLD_WIDTH, type SimulationCommand } from './simulation/types';

export class GameRuntime {
  private readonly scene = new BattleScene();
  private readonly game: Phaser.Game;

  constructor(onFrame: (frame: RuntimeFrame) => void) {
    this.scene.onFrame = onFrame;
    this.game = new Phaser.Game({
      type: Phaser.AUTO,
      width: WORLD_WIDTH,
      height: WORLD_HEIGHT,
      parent: 'game-container',
      transparent: false,
      backgroundColor: '#05070F',
      render: { antialias: true, pixelArt: false, roundPixels: false },
      scale: {
        mode: Phaser.Scale.FIT,
        autoCenter: Phaser.Scale.CENTER_BOTH,
        width: WORLD_WIDTH,
        height: WORLD_HEIGHT,
      },
      scene: [this.scene],
      input: { activePointers: 2 },
      audio: { disableWebAudio: false },
      fps: { target: 60, min: 30, smoothStep: true },
    });
  }

  setSimulation(simulation: Simulation | null): void {
    this.scene.setSimulation(simulation);
  }

  command(command: SimulationCommand): void {
    this.scene.enqueue(command);
  }

  setSpeed(speed: number): void {
    this.scene.setSpeed(speed);
  }

  setSettings(settings: PlayerSettings): void {
    this.scene.setSettings(settings);
  }

  setCosmetics(cosmetics: CosmeticLoadout): void {
    this.scene.setCosmetics(cosmetics);
  }

  destroy(): void {
    this.game.destroy(true);
  }
}
